module.exports = __webpack_public_path__ + "img/rule1.d7862043.png";